import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { SelectedSectionFiltersModel } from '../models/selected_section_filters_model';
import { CommunicatorService } from 'ui-ng-component-communicator';

export type ClearSectionFiltersCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'clearSectionFiltersCommand',
    function clearSectionFiltersCommandDefinition(
      defineCommandORM: IDefineCommand,
      ngSelectedSectionFiltersModel: SelectedSectionFiltersModel,
      ngComponentCommunicatorService: CommunicatorService
    ) {
      'use strict';
      return defineCommandORM('clearSectionFiltersCommand', function clearSectionFiltersCommand(deferred) {
        ngSelectedSectionFiltersModel.clear().write({
          instructors: [],
          section_labels: []
        });

        ngComponentCommunicatorService.publish('CLEAR_EXISTING_FILTERS');
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_filters/commands/clear_section_filters_command.ts